/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

// import NewContentList from "./NewContentList";

// import Event202104_contentList from "./Event202104_contentList";
// import parse from "html-react-parser";
//import '../../css/event20210317.css'
//import '../../css/event210521.css'
//import '../../css/event210629.css'
//import '../../css/event210819.css'
import "../../css/event211020.css";
// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import moment from "moment";
// import Slider from "react-slick";
import { isMobile } from "react-device-detect";
import $ from "jquery";
import ReactPlayer from "react-player";

class Event202305_offical_char extends Component {
  state = {
    playing: false,
    videoUrl: "https://jjmp4.ofscdn.com/TveeMovie/aniplus/aniplus_char.mp4",
  };
  componentDidMount = () => {
    this._getWindowSize();
  };
  _getWindowSize = () => {
    $("img[usemap]").rwdImageMaps();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _onBack = () => {
    const { history } = this.props;

    history.goBack();
  };
  _google = () => {
    window.open(
      "https://docs.google.com/forms/d/e/1FAIpQLSfVeczLzjkZr-JGGCzjAjoPznkjHRj8OsI9M6IsFFyU8F9rcQ/viewform?usp=sf_link",
      "",
      ""
    );
  };
  _play = () => {
    this.setState({
      playing: true,
    });
  };
  _onEnded = () => {
    this.setState({
      playing: false,
    });
  };
  render() {
    const { playing, videoUrl } = this.state;

    return (
      <Fragment>
        <div className="event_head">
          <h3>애니플러스 오리지널 캐릭터 이름 공모전</h3>
          <button
            type="button"
            className="btnClose"
            onClick={this._onBack}
            style={{ pointer: "cursor" }}
          >
            <img src="/img/detail_img/close_1.png" alt="닫기" />
          </button>
        </div>
        <div className="eventCon">
          {isMobile ? (
            <Fragment>
              <div>
                <img src="/img/event/event20230530/m_img01.jpg" />
              </div>
              <div>
                <div style={{ display: "inline-block", height: 213 }}>
                  {playing ? (
                    <div
                      style={{
                        position: "absolute",
                        textAlign: "center",
                        width: "inherit",
                      }}
                    >
                      <ReactPlayer
                        // ref={(ref) => (this.video = ref)}
                        url={videoUrl}
                        playing={playing}
                        controls
                        width={"100%"}
                        height={isMobile ? "auto" : "auto"}
                        onEnded={this._onEnded}
                        //width={isMobile ? 320 : 640}
                      />
                    </div>
                  ) : (
                    <img
                      src="/img/event/event20230530/m_img02.jpg"
                      onClick={this._play}
                    />
                  )}
                </div>
              </div>
              <div>
                <img src="/img/event/event20230530/m_img03.jpg" />
              </div>
              <div>
                <img src="/img/event/event20230530/m_img04.jpg" />
              </div>
              <div>
                <img src="/img/event/event20230530/m_img05.jpg" />
              </div>
              <div>
                <img src="/img/event/event20230530/m_img06.jpg" />
              </div>
              <div>
                <img
                  src="/img/event/event20230530/m_img07.jpg"
                  onClick={this._google}
                />
              </div>
            </Fragment>
          ) : (
            <Fragment>
              <div>
                <img src="/img/event/event20230530/img01.jpg" />
              </div>
              <div>
                <div style={{ display: "inline-block", width: "14.7%" }}>
                  <img src="/img/event/event20230530/img02.jpg" />
                </div>
                <div
                  style={{
                    display: "inline-block",
                    width: "70.6%",
                    padding: 0,
                    margin: 0,
                  }}
                >
                  {playing ? (
                    <div
                      style={{
                        position: "absolute",
                        textAlign: "center",
                        width: "inherit",
                        // paddingTop: -20,
                        marginTop: -30,
                      }}
                    >
                      <ReactPlayer
                        // ref={(ref) => (this.video = ref)}
                        url={videoUrl}
                        playing={playing}
                        controls
                        width={"100%"}
                        height={isMobile ? 320 : "auto"}
                        onEnded={this._onEnded}
                        //width={isMobile ? 320 : 640}
                      />
                    </div>
                  ) : (
                    <img
                      src="/img/event/event20230530/img03.jpg"
                      onClick={this._play}
                    />
                  )}
                </div>
                <div style={{ display: "inline-block", width: "14.7%" }}>
                  <img src="/img/event/event20230530/img04.jpg" />
                </div>
              </div>
              <div>
                <img src="/img/event/event20230530/img05.jpg" />
              </div>
              <div>
                <img src="/img/event/event20230530/img06.jpg" />
              </div>
              <div>
                <img src="/img/event/event20230530/img07.jpg" />
              </div>
              <div>
                <img src="/img/event/event20230530/img08.jpg" />
              </div>
              <div>
                <img
                  src="/img/event/event20230530/img09.jpg"
                  onClick={this._google}
                  style={{ cursor: "pointer" }}
                />
              </div>

              {/* 
              <img
                src="/img/event/event20230530/original_char.jpg"
                useMap="#Map2"
                onClick={this._play}
              /> */}
            </Fragment>
          )}
        </div>
      </Fragment>
    );
  }
}
const styles = {
  clsDiv: {
    display: "inline-block",
    padding: 0,
    margin: 0,
  },
};
export default shopContext(withRouter(Event202305_offical_char));
